import { IMainNavigationChildItem, IMainNavigationItem } from './main-navigation-items';
import { ITenantAddons } from '../../tenant-addons';
import { ResourceAction } from '../../../authentication/authorization-service';
import { AllowedActions } from '../../../authentication/allowed-actions';

export function getFilteredItems(
  mainNavigationItems: IMainNavigationItem[],
  tenantAddons: ITenantAddons,
  isFeatureEnabled: <T extends string = string>(featureName: T) => boolean,
  allowedActions: AllowedActions,
  hasServiceProviderAreaAccess = false,
  hasServiceProviderRole = false
) {
  const isChildVisible = (child: IMainNavigationChildItem) =>
    checkUserHasAccess(child.resourceActions, allowedActions) &&
    checkIsTenantAddonEnabled(tenantAddons, child.tenantAddons) &&
    checkIsFeatureToggleRequired(isFeatureEnabled, child.featureToggleRequired) &&
    checkHideWithFeatureToggle(isFeatureEnabled, child.hideWithFeatureToggle) &&
    checkServiceProviderAreaAccess(child.requiresServiceProviderAreaAccess, hasServiceProviderAreaAccess) &&
    (!child.requiresServiceProviderRole || hasServiceProviderRole);

  let filteredItems = [...mainNavigationItems].filter((item: IMainNavigationItem) => {
    if (!checkUserHasAccess(item.resourceActions, allowedActions)) {
      return false;
    }
    if (!checkIsTenantAddonEnabled(tenantAddons, item.tenantAddons)) {
      return false;
    }
    if (item.requiresServiceProviderRole && !hasServiceProviderRole) {
      return false;
    }
    if (item.children && !item.children.some(isChildVisible)) {
      return false;
    }
    if (item.featureToggleRequired) {
      const featureTogglingEnabled = isFeatureEnabled(item.featureToggleRequired);
      if (!featureTogglingEnabled) {
        return false;
      }
    }

    if (item.hideWithFeatureToggle) {
      const hideWithFeatureToggle = isFeatureEnabled(item.hideWithFeatureToggle);
      if (hideWithFeatureToggle) {
        return false;
      }
    }
    return true;
  });

  filteredItems = filteredItems.map(x => ({
    ...x,
    children: [...(x.children || []).filter(isChildVisible)],
  }));
  return filteredItems;
}

function checkUserHasAccess(actions: ResourceAction[] | undefined, allowedActions: AllowedActions) {
  if (actions) {
    return allowedActions.isAnyAllowed(actions);
  }

  return true;
}

function checkServiceProviderAreaAccess(requiresServiceProviderAreaAccess: boolean | undefined, hasServiceProviderAreaAccess: boolean) {
  if (requiresServiceProviderAreaAccess) {
    return hasServiceProviderAreaAccess;
  }
  return true;
}

function checkIsTenantAddonEnabled(tenantAddons: ITenantAddons, addonNames?: string[]) {
  if (tenantAddons && addonNames) {
    return tenantAddons.isTenantAddonEnabled(addonNames);
  }
  return true;
}

function checkIsFeatureToggleRequired(isFeatureEnabled: <T extends string = string>(featureName: T) => boolean, featureToggleRequired: string | undefined) {
  if (featureToggleRequired) {
    const featureTogglingEnabled = isFeatureEnabled(featureToggleRequired);
    if (!featureTogglingEnabled) {
      return false;
    }
  }

  return true;
}

function checkHideWithFeatureToggle(isFeatureEnabled: <T extends string = string>(featureName: T) => boolean, featureToggleRequired: string | undefined) {
  if (featureToggleRequired) {
    const featureTogglingEnabled = isFeatureEnabled(featureToggleRequired);
    if (featureTogglingEnabled) {
      return false;
    }
  }

  return true;
}
